import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MasterDataService {

  constructor(private http: HttpClient) { }

  /*  uploadMasterData(templateName: string): Observable<any> {
      const url = `${environment.apiOrigin}/api/master-data/${templateName}`;
      return this.http.put(url, '');
    }*/

  uploadFiles(files: any, templateName: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/master-data/${templateName}`;
    const formData: FormData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i], files[i].name);
    }
    return this.http.put(url, formData);
  }

  getMyMasterData(): Observable<any> {
    const url = `${environment.apiOrigin}/api/master-data-upload-queues`;
    // const url = `${environment.apiOrigin}/api/get-master-data`;
    return this.http.get(url);
  }
  getFailedRecord(id: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/get-master-data/${id}`;
    return this.http.get(url);
  }
}
